/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Warehouse_StatsInputs */

const vi_nav_warehouse_stats = /** @type {(inputs: Nav_Warehouse_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê kho`)
};

/**

* @param {Nav_Warehouse_StatsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_warehouse_stats = /** @type {((inputs?: Nav_Warehouse_StatsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Warehouse_StatsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_warehouse_stats(inputs)
});